import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Moon, Sun, LogOut } from "lucide-react";

const pageTitles = {
  "/": "Dashboard",
  "/quotation": "Create Quotation",
  "/invoice": "Create Invoice / Bill",
  "/service-bill": "Service Bill",
  "/records": "View Records",
};

const Header = ({ onSignOut }) => {
  const location = useLocation();
  const [darkMode, setDarkMode] = useState(false);

  const pageTitle = pageTitles[location.pathname] || "SHREE MOBILITY TRADE";

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  return (
    <header className="sticky top-0 z-20 bg-card/95 backdrop-blur-sm border-b border-border px-4 lg:px-6 h-16 flex items-center justify-between no-print">
      {/* Page Title + Panel Badge */}
      <div className="lg:ml-0 ml-14 flex items-center gap-3">
        <h1 className="font-heading font-semibold text-lg text-foreground">
          {pageTitle}
        </h1>
        <Badge
          variant="outline"
          className="hidden sm:inline-flex text-xs border-primary/40 text-primary bg-primary/5"
        >
          Dealership Panel
        </Badge>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-2">
        {/* Theme Toggle */}
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setDarkMode(!darkMode)}
          className="text-muted-foreground hover:text-foreground"
          title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
          {darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </Button>

        {/* Sign Out — clearly visible */}
        <Button
          variant="outline"
          size="sm"
          onClick={onSignOut}
          className="gap-2 text-destructive border-destructive/30 hover:bg-destructive/10 hover:border-destructive/60"
          id="sign-out-btn"
        >
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Sign Out</span>
        </Button>
      </div>
    </header>
  );
};

export default Header;
